import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { getServiceIdSelector } from '../../user/selectors'
import { DrainService } from '../../procedures/drain/services/drain.service'
import { IIntercostalSpaceOptions } from '../store/options.types'

import * as actions from '../store/options.actions'

interface IIntercostalSpaceOptionsResponse {
  entity: IIntercostalSpaceOptions
}

export function* setDrainIntercostalSpaceOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const drainService = new DrainService(serviceId)
  try {
    const response: IIntercostalSpaceOptionsResponse = yield call([
      drainService,
      drainService.getIntercostalSpaceOptions,
    ])
    const { entity } = response
    yield put(actions.setDrainIntercostalSpaceOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setDrainIntercostalSpaceOptions() error: ${e}`))
  }
}
export function* setDrainIntercostalSpaceOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setDrainIntercostalSpaceOptions)
}
